import { render } from "./IconLegend.vue?vue&type=template&id=5cf424ac"
import script from "./IconLegend.vue?vue&type=script&lang=js"
export * from "./IconLegend.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__